import { defineStore } from "pinia";
import { ref } from 'vue';

export const useCommonStore = defineStore('common', () => {
     //const cloudfrontURL = ref('https://website-public-assets.clarityglobal.com/saleswebsitevuejs/');
     const cloudfrontURL = ref('https://website-public-assets.clarityglobal.com/assets/');
     const cloudfrontImgURL = ref(cloudfrontURL.value + 'images/');
     const cloudfrontIconURL = ref(cloudfrontURL.value + 'icons/');
     const cloudfrontPdfURL = ref(cloudfrontURL.value + 'pdf/');
     const customerThermometerURL = ref('https://app.customerthermometer.com/api.php?apiKey=3b04fda5d5543889b844582465455457&getMethod=getHappinessValue');
     const googleSearchURL = ref('https://customsearch.googleapis.com/customsearch/v1');
     const googleSearchKey = ref('AIzaSyDnN0ykxxi05_fqVEsrFU16Q2xVnHN-Mn8&cx=93c55f651ff94141c');
     const homepageSchema = ref(`{
          "@context": "https://schema.org",
          "@type": "FinancialService",
          "name": "Clarity",
          "url": "https://www.clarityglobal.com/homepage",
          "logo": "https://www.clarityglobal.com/logo.png",
          "description": "Trusted advice for individuals, families, and employers. Plan, invest, and protect your future with expert financial planners at clarity.",
          "areaServed": 
          {
               "@type": "Country",
               "name": "United Kingdom"
          },
          "contactPoint": 
          {
               "@type": "ContactPoint",
               "telephone": "+44-800-368-7511",
               "contactType": "Customer Service"
          },
          "sameAs": [
               "https://www.linkedin.com/company/clarity_7",
               "https://www.instagram.com/clarity_global"
          ]
     }`);
     const whatWeDoSchema = ref(`{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "What We Do | Financial Planning, Investment & Wealth Succession",
          "url": "https://www.clarityglobal.com/whatwedo",
          "description": "Explore our services - from financial planning and investment management to pensions, tax strategies, and intergenerational wealth planning."
     }`);    
     const whoWeHelpSchema = ref(`{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Who We Help | Individuals, Families & Trustees",
          "url": "https://www.clarityglobal.com/whowehelp",
          "description": "clarity works with individuals, families and trustees to deliver financial strategies that support long-term goals and values-driven decisions."
     }`);
     const insightsSchema = ref(`{
          "@context": "https://schema.org",
          "@type": "Blog",
          "name": "Insights, Market Updates & clarityON Podcast",
          "url": "https://www.clarityglobal.com/insights",
          "description": "Stay informed with expert insights on markets, tax, pensions, and investments and updates financial planning team. Plus listen to our clarityON podcast."
     }`);
     const employersSchema = ref(`{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Employers",
          "url": "https://www.clarityglobal.com/employers",
          "description": "Help your employees feel financially confident. Our clarityHORIZONS platform and bespoke financial wellbeing services support workforce engagement and retention."
     }`);
     const meetTheTeamSchema = ref(`{
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Clarity",
          "url": "https://www.clarityglobal.com/meettheteam",
          "employee": [
               {
                    "@type": "Person",
                    "name": "Angus Jones",
                    "jobTitle": "Founder and CEO"
               },
               {
                    "@type": "Person",
                    "name": "Glyn Bolton",
                    "jobTitle": "Investment Director"
               },
               {
                    "@type": "Person",
                    "name": "Claire Brooks",
                    "jobTitle": "Associate Technical Director"
               },
               {
                    "@type": "Person",
                    "name": "Daniel Smith",
                    "jobTitle": "Senior Adviser"
               },
               {
                    "@type": "Person",
                    "name": "Vicki Watson",
                    "jobTitle": "Adviser"
               },
               {
                    "@type": "Person",
                    "name": "Naomi Kewell",
                    "jobTitle": "Adviser"
               },
               {
                    "@type": "Person",
                    "name": "Craig Porter",
                    "jobTitle": "Adviser"
               },
               {
                    "@type": "Person",
                    "name": "David Eve",
                    "jobTitle": "Investment Manager"
               },
               {
                    "@type": "Person",
                    "name": "Sara Hussain",
                    "jobTitle": "Investment Analyst"
               },
               {
                    "@type": "Person",
                    "name": "Chris Finch",
                    "jobTitle": "Investment Analyst"
               }
          ]
     }`);
     const clarityOnlineSchema = ref(`{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "clarityONLINE Portal & Mobile Application Download",
          "url": "https://clientportal.clarityglobal.com/login?path=/",
          "description": "Track investments, download reports, securely message your adviser, and manage your finances anytime with the clarityONLINE app and portal."
     }`);
     const mishconSchema = ref(`{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "MDRclarity | Integrated Financial Advice for Employees",
          "url": "https://www.clarityglobal.com/mishcon",
          "description": "Discover how MDRclarity can provide comprehensive financial planning and wealth management tailored to legal professionals and their clients."
     }`);
     const pwcSchema = ref(`{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "clarity & PwC | Financial Planning & Advice for Employees",
          "url": "https://www.clarityglobal.com/pwc",
          "description": "clarity partners with PwC to offer tailored financial planning, our portal is integrated with the PwC’s AIR system simplifying personal independence compliance."
     }`);
     const searchResultsSchema = ref(`{
          "@context": "https://schema.org",
          "@type": "SearchResultsPage",
          "name": "Search Results | Find Content on clarity’s Website",
          "url": "https://www.clarityglobal.com/searchresults?q="
     }`);
     const errorPageSchema = ref(`{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "Page Not Found | Explore clarity’s Website",
          "url": "https://www.clarityglobal.com/error",
          "description": "Oops! The page you’re looking for isn’t available. Use the navigation above to explore financial planning, investments, and employee wellbeing services."
     }`);
     const retirementCalculatorSchema = ref(`{
          "@context": "https://schema.org",
          "@graph": [
          {
          "@type": "WebApplication",
          "name": "Retirement Calculator",
          "url": "https://www.clarityglobal.com/retirement-calculator",
          "description": "Free retirement calculator to help you plan your financial future. Check if your savings will last through retirement and discover what you need to top up your pension pot.",
          "applicationCategory": "FinanceApplication",
          "operatingSystem": "Any",
          "browserRequirements": "Requires JavaScript",
          "offers": {
               "@type": "Offer",
               "price": "0",
               "priceCurrency": "GBP",
               "availability": "https://schema.org/InStock",
               "priceValidUntil": "2026-12-31"
               },
          "featureList": [
               "Calculate retirement income",
               "Estimate pension contributions",
               "Check if savings will last through retirement",
               "Plan retirement savings",
               "Free personalized retirement insights"
               ],
          "provider": {
               "@type": "FinancialService",
               "name": "clarity",
               "url": "https://www.clarityglobal.com",
               "address": {
               "@type": "PostalAddress",
               "addressCountry": "GB"
               }
               },
          "audience": {
               "@type": "Audience",
               "audienceType": "Individuals planning for retirement"
               },
          "isAccessibleForFree": true
          },
          {
          "@type": "VideoObject",
          "name": "About clarity",
          "description": "Learn about clarity and how we can help you manage your finances",
          "uploadDate": "2024-01-01",
          "contentUrl": "https://www.clarityglobal.com/retirement-calculator",
          "embedUrl": "https://www.clarityglobal.com/retirement-calculator",
          "publisher": {
               "@type": "Organization",
               "name": "clarity",
               "url": "https://www.clarityglobal.com"
               }
          },
          {
          "@type": "ItemList",
          "name": "Latest Insights",
          "description": "Recent articles and insights about financial planning",
          "itemListElement": [
               {
               "@type": "ListItem",
               "position": 1,
               "url": "https://www.clarityglobal.com/insights"
               }
               ]
          },
          {
          "@type": "BreadcrumbList",
          "itemListElement": [
               {
               "@type": "ListItem",
               "position": 1,
               "name": "Home",
               "item": "https://www.clarityglobal.com"
               },
               {
               "@type": "ListItem",
               "position": 2,
               "name": "Retirement Calculator",
               "item": "https://www.clarityglobal.com/retirement-calculator"
               }
               ]
          },
          {
          "@type": "WebPage",
          "name": "Retirement Calculator",
          "url": "https://www.clarityglobal.com/retirement-calculator",
          "description": "Plan your ideal retirement with clarity's free calculator. Discover if your savings are on track to last your retirement and what you need to ensure they are.",
          "isPartOf": {
               "@type": "WebSite",
               "name": "clarity",
               "url": "https://www.clarityglobal.com"
               },
          "about": {
               "@type": "Thing",
               "name": "Retirement Planning"
               },
          "mainEntity": {
               "@type": "SoftwareApplication",
               "name": "Free Retirement Calculator",
               "applicationCategory": "FinanceApplication",
               "offers": {
               "@type": "Offer",
               "price": "0",
               "priceCurrency": "GBP"
               }
               }
          }
          ]
     }`);
     const schoolsPageSchema = ref(`{}`);

     function environment() {
          return window.location.hostname;
     }

     function usePageNavigation() {
          const route = window.location.pathname;
          var useNav = true;
          switch (route) {
               // Add routes here that don't use the menu bar - setting useNav to false.
               case '/clientreferral':
                    useNav = true;
                    break;
               default:
                    useNav = true;
                    break;
          }
          return useNav;
     }

     function metaDescriptionTag(page) {
          var meta = document.createElement('meta');
          meta.name = 'description';
          meta.content = null;
          switch (page) {
               case 'homepage':
                    meta.content = 'Trusted financial advice and wealth management for individuals, families, and employers across the UK. With offices in Surrey, Cambridge, and London, clarity helps you plan, invest, and protect your future.';
                    break;
               case 'clarityOnline':
                    meta.content = 'Track your investments, download reports, securely message your adviser and manage your finances anytime with clarityONLINE portal and app.';
                    break;
               case 'employers':
                    meta.content = 'Help your employees feel financially confident. Our clarityHORIZONS platform and bespoke financial wellbeing services support workforce engagement and retention.';
                    break;
               case 'insights':
                    meta.content = 'Stay informed with expert insights on markets, tax, pensions, and investments and updates financial planning team. Plus listen to our clarityON podcast.';
                    break;
               case 'meetTheTeam':
                    meta.content = 'Get to know clarity’s experienced team of Chartered Financial Planners and Investment Analysts. We’re here to support your goals.';
                    break;
               case 'whatWeDo':
                    meta.content = 'Explore clarity’s services—from financial planning and investment management to pensions, tax strategies, and intergenerational wealth planning.';
                    break;
               case 'whoWeHelp':
                    meta.content = 'clarity works with individuals, families and trustees to deliver financial strategies that support long-term goals and values-driven decisions.';
                    break;
               case 'mishcon':
                    meta.content = 'Discover how MDRclarity can provide comprehensive financial planning and wealth management tailored to legal professionals and their clients.';
                    break;
               case 'pwc':
                    meta.content = 'clarity partners with PwC to offer tailored financial planning, our portal is integrated with the PwC’s AIR system simplifying personal independence compliance.';
                    break;
               case 'searchResults':
                    meta.content = 'Browse our site to find relevant articles, services, and expert insights on financial planning, investment, and employee benefits.';
                    break;
               case 'error':
                    meta.content = 'Oops! The page you’re looking for isn’t available. Use the navigation above to explore financial planning, investments, and employee wellbeing services.';
                    break;
               case 'bookacall':
                    meta.content = 'Speak with Louise Challis, clarity’s Partnerships Manager, to explore how we can help you plan for the future. Book your free initial call today.';
                    break;
               case 'retirementcalculator':
                    meta.content = 'Will your retirement savings last? Use our free calculator to find out if you\'re on track and to discover how much income you will need when you retire.';
                    break;
               case 'schools':
                    meta.content = 'Specialist investment management for independent schools and trusts. ESG options, governance support and free financial education for students';
                    break;
               default:
                    meta.content = 'Trusted advice for individuals, families, and employers. Plan, invest, and protect your future with expert financial planners at clarity.';
                    break;
          }
          document.getElementsByTagName('head')[0].appendChild(meta);
     }

     function schemaScript(page) {
          // console.log(page);
          var script = document.createElement('script');
          script.type = "application/ld+json";
          script.textContent = null;
          switch (page) {
               case 'homepage':
                    script.textContent = homepageSchema.value;
                    break;
               case 'clarityOnline':
                    script.textContent = clarityOnlineSchema.value;
                    break;
               case 'employers':
                    script.textContent = employersSchema.value;
                    break;
               case 'insights':
                    script.textContent = insightsSchema.value;
                    break;
               case 'meetTheTeam':
                    script.textContent = meetTheTeamSchema.value;
                    break;
               case 'whatWeDo':
                    script.textContent = whatWeDoSchema.value;
                    break;
               case 'whoWeHelp':
                    script.textContent = whoWeHelpSchema.value;
                    break;
               case 'mishcon':
                    script.textContent = mishconSchema.value;
                    break;
               case 'pwc':
                    script.textContent = pwcSchema.value;
                    break;
               case 'searchResults':
                    script.textContent = searchResultsSchema.value;
                    break;
               case 'error':
                    script.textContent = errorPageSchema.value;
                    break;
               case 'retirementcalculator':
                    script.textContent = retirementCalculatorSchema.value;
                    break;
               case 'schools':
                    script.textContent = schoolsPageSchema.value;
                    break;
               default:
                    script.textContent = homepageSchema.value;
                    break;
          }
          document.getElementsByTagName('head')[0].appendChild(script);
     }

     function rdLoginURL() {
          const env = environment();
          var url = '';
          switch (env) {
               case 'localhost':
               case 'rdsales.clarityglobal.com':
                    url = 'https://localhost:8080';
                    break;
               case 'dev.dtxxiwp6mpjk6.amplifyapp.com':
                    url = 'https://dev-clientportal.clarityglobal.com';
                    break;
               case 'prod.dtxxiwp6mpjk6.amplifyapp.com':
                    url = 'https://clientportal.clarityglobal.com';
                    break;
               default:
                    url = 'https://clientportal.clarityglobal.com';
                    break;
          }
          return url;
     }

     function rdSignupURL() {
          const env = environment();
          var url = '';
          switch (env) {
               case 'localhost':
               case 'rdsales.clarityglobal.com':
                    url = 'https://localhost:8080/createaccount';
                    break;
               case 'dev.dtxxiwp6mpjk6.amplifyapp.com':
                    url = 'https://dev-clientportal.clarityglobal.com/createaccount';
                    break;
               case 'prod.dtxxiwp6mpjk6.amplifyapp.com':
                    url = 'https://clientportal.clarityglobal.com/createaccount';
                    break;
               default:
                    url = 'https://clientportal.clarityglobal.com/createaccount';
                    break;
          }
          return url;
     }

     function d10Prefix() {
          const env = environment();
          var prefix = '';
          switch (env) {
               case 'localhost':
               case 'rdsales.clarityglobal.com':
                    prefix = 'https://drupal9clarity.ddev.site';
                    break;
               case 'dev.dtxxiwp6mpjk6.amplifyapp.com':
                    prefix = 'https://admin-access.dev.clarityglobal.com';
                    break;
               case 'prod.dtxxiwp6mpjk6.amplifyapp.com':
                    prefix = 'https://admin-access.prod.clarityglobal.com';
                    break;
               default:
                    prefix = 'https://admin-access.prod.clarityglobal.com';
                    break;
          }
          return prefix;
     }

     function contactUsURL() {
          const env = environment();
          var url = '';
          switch(env) {
               case 'localhost':
               case 'rdsales.clarityglobal.com':
                    url = 'https://developer-d9.clarityglobal.com/contactform';
                    break;
               case 'dev.dtxxiwp6mpjk6.amplifyapp.com':
                    url = 'https://backend.dev.clarityglobal.com/contactform';
                    break;
               case 'prod.dtxxiwp6mpjk6.amplifyapp.com':
                    url = 'https://backend.prod.clarityglobal.com/contactform';
                    break;
               default:
                    url = 'https://backend.prod.clarityglobal.com/contactform';
                    break;
          }
          return url;
     }

     function reCaptchaURL() {
          const env = environment();
          var url = '';
          switch(env) {
               case 'localhost':
               case 'rdsales.clarityglobal.com':
                    url = 'https://developer-d9.clarityglobal.com/recaptchaverify';
                    break;
               case 'dev.dtxxiwp6mpjk6.amplifyapp.com':
                    url = 'https://backend.dev.clarityglobal.com/recaptchaverify';
                    break;
               case 'prod.dtxxiwp6mpjk6.amplifyapp.com':
                    url = 'https://backend.prod.clarityglobal.com/recaptchaverify';
                    break;
               default:
                    url = 'https://backend.prod.clarityglobal.com/recaptchaverify';
                    break;
          }
          return url;
     }

     function meetTheTeamURL() {
          const env = environment();
          var url = '';
          switch(env) {
               case 'localhost':
               case 'rdsales.clarityglobal.com':
                    url = 'https://developer-d9.clarityglobal.com/teamprofiles';
                    break;
               case 'dev.dtxxiwp6mpjk6.amplifyapp.com':
                    url = 'https://backend.dev.clarityglobal.com/teamprofiles';
                    break;
               case 'prod.dtxxiwp6mpjk6.amplifyapp.com':
                    url = 'https://backend.prod.clarityglobal.com/teamprofiles';
                    break;
               default:
                    url = 'https://backend.prod.clarityglobal.com/teamprofiles';
                    break;
          }
          return url;
     }

     function insigntsURL() {
          const env = environment();
          var url = '';
          switch(env) {
               case 'localhost':
               case 'rdsales.clarityglobal.com':
                    //url = 'https://developer-d9.clarityglobal.com/anon/insights';
                    //break;
               case 'dev.dtxxiwp6mpjk6.amplifyapp.com':
                    url = 'https://backend.dev.clarityglobal.com/anon/insights';
                    break;
               case 'prod.dtxxiwp6mpjk6.amplifyapp.com':
                    url = 'https://backend.prod.clarityglobal.com/anon/insights';
                    break;
               default:
                    url = 'https://backend.prod.clarityglobal.com/anon/insights';
                    break;
          }
          return url;
     }

     function clientFeedbackURL() {
          const env = environment();
          var url = '';
          switch(env) {
               case 'localhost':
               case 'rdsales.clarityglobal.com':
                    url = 'https://developer-d9.clarityglobal.com/testimonials';
                    break;
               case 'dev.dtxxiwp6mpjk6.amplifyapp.com':
                    url = 'https://backend.dev.clarityglobal.com/testimonials';
                    break;
               case 'prod.dtxxiwp6mpjk6.amplifyapp.com':
                    url = 'https://backend.prod.clarityglobal.com/testimonials';
                    break;
               default:
                    url = 'https://backend.prod.clarityglobal.com/testimonials';
                    break;
          }
          return url;
     }

     function clientReferralURL() {
          const env = environment();
          var url = '';
          switch(env) {
               case 'localhost':
               case 'rdsales.clarityglobal.com':
                    url = 'https://backend.dev.clarityglobal.com/anon/referral';
                    //url = 'https://developer-d9.clarityglobal.com/anon/referral';
                    break;
               case 'dev.dtxxiwp6mpjk6.amplifyapp.com':
                    url = 'https://backend.dev.clarityglobal.com/anon/referral';
                    break;
               case 'prod.dtxxiwp6mpjk6.amplifyapp.com':
                    url = 'https://backend.prod.clarityglobal.com/anon/referral';
                    break;
               default:
                    url = 'https://backend.prod.clarityglobal.com/anon/referral';
                    break;
          }
          return url;
     }

     function isProduction() {
          const env = environment();
          var isProd = false;
          switch(env) {
               case 'localhost':
                    isProd = false;
                    break;
               case 'rdsales.clarityglobal.com':
                    isProd = false;
                    break;
               case 'dev.dtxxiwp6mpjk6.amplifyapp.com':
                    isProd = false;
                    break;
               case 'prod.dtxxiwp6mpjk6.amplifyapp.com':
                    isProd = true;
                    break;
               default:
                    isProd = true;
                    break;
          }
          return isProd;
     }

     return { cloudfrontURL, cloudfrontImgURL, cloudfrontIconURL, cloudfrontPdfURL, customerThermometerURL, googleSearchURL, googleSearchKey, environment, rdLoginURL, rdSignupURL, d10Prefix, contactUsURL, reCaptchaURL, meetTheTeamURL, insigntsURL, clientFeedbackURL, clientReferralURL, usePageNavigation, metaDescriptionTag, schemaScript, isProduction }
});